var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"topList"}},_vm._l((_vm.navList),function(item,i){return _c('div',{key:i,class:_vm.act === i ? 'act' : 'none',on:{"click":function($event){return _vm.setAct(i)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }